// Header offset for JS-driven anchor scrolls. Must stay in sync with
// scroll-padding-top in public-globals.css and --public-header-height.
const SCROLL_HEADER_OFFSET = 96;

export function scrollToElement(id: string, offset: number = SCROLL_HEADER_OFFSET) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({
    top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset),
    behavior: reduce ? "auto" : "smooth",
  });
}
